/*
 * Title: Polyfill for NodeList forEach in IE11*
 * Source: https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach
 * Description: The forEach() method of the NodeList interface calls the callback given in parameter once for each value pair in the list, in insertion order.
 * Commentary: This allows us (RMP) to use document.querySelectorAll('.Notice').forEach(() => ) without constantly casting to and array e.g. Array.from(document.querySelectorAll('.Notice'))
 */

/* eslint-disable */
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}
/* eslint-enable */
